import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'
import { useGlobalizedLayers } from '@state/layout/queries'
import {
  type LayerWithGeometry
} from '@utils/geometry.ts'

function Bretter() {
  const { mapOrigin } = useStoreMapContext()
  const { data: bretter = new Map<string, LayerWithGeometry>() } = useGlobalizedLayers({ mapOrigin })

  return Array.from(bretter.values()).map(layer => {
    const { position, width, height, depth } = layer.geometry

    return (
      <mesh
        key={layer.layerId}
        position={[position.x, position.z, position.y]}
        quaternion={layer.quaternion}
        scale={1.01}
      >
        <boxGeometry args={[width, height, depth]} />
        <meshStandardMaterial color="#A3AFB9" />
      </mesh>
    )
  })
}

export default Bretter